import React, { useState, useRef, useEffect, useContext } from 'react'
import { Button, Fade, Tooltip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import './ProductCard.css'
import FavouriteCheckbox from '@/product/components/atoms/FavoriteCheckbox'
// import Popup from '@/custom/organisms/Popup'
import Timer from '@/product/common/timer'
import Buynow from '../Buynow/BuynowItem'
import { dateFormatFront, HtmlToText } from '@/custom/common/components'
import { handleRedirectInternal, currencyFormat } from '@/custom/common/components'
import CommonContext from '@/product/context/common/commonContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import ReverseBidding from '@/custom/components/molecules/Reverse/Bidding/BiddingItem'
import Bidding from '../Bidding/BiddingItem'
import { FALLBACK_IMAGE } from '@/utils'
const ListView = (props) => {
    const [addCard, setAddCard] = useState(false)
    const product = props.data
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const customCommonContext = useContext(CustomCommonContext)

    const { user, isAuthenticated } = authContext
    const { setBidHistoryValue } = commonContext
    const { configVariables } = customCommonContext

    const history = useHistory()

    const toggleModal = (state, action) => {
        setAddCard(!addCard)
    }
    return (
        <Fade in={true} timeout={600}>
            <div className="productCardList d-flex justify-content-between align-items-start">
                <div className="psListLt d-flex">
                    <div className="pclImg">
                        <img
                            src={
                                product.avatar
                                    ? product.avatar
                                    : `${global.site_url}/uploads/product/${product.avatar}`
                            }
                            onError={(e) => FALLBACK_IMAGE(e)}
                            alt={product.title}
                        />
                        {/* <FavouriteCheckbox
                            watchlisted={product.watchlistid}
                            project_id={product.id}
                        /> */}
                        <div className="listBidStatus">
                            {isAuthenticated && (
                                <>
                                    {product.bidtopstatus === 'outbid' && (
                                        <h4 className="productWinningStatus outbid">
                                            {product.wprice < product.rprice
                                                ? 'Reserve not met'
                                                : 'Outbid'}
                                        </h4>
                                    )}
                                    {product.bidtopstatus === 'winner' && (
                                        <h4 className="productWinningStatus winning">
                                            {product.wprice < product.rprice
                                                ? 'Reserve not met'
                                                : 'Winning'}
                                        </h4>
                                    )}
                                    {product.bidtopstatus === 'won' && (
                                        <h4 className="productWinningStatus won">{'Won'}</h4>
                                    )}
                                    {product.bidtopstatus === 'lost' && (
                                        <h4 className="productWinningStatus lost">{'Lost'}</h4>
                                    )}
                                    {/* {(product.bidtopstatus === 'outbid' ||
                                        product.bidtopstatus === 'winner') &&
                                        product.wprice <= product.rprice && (
                                            <>
                                                <Tooltip title="Reserve price not met">
                                                    <span className="material-icons reserveNotMet">
                                                        lock_open
                                                    </span>
                                                </Tooltip>
                                            </>
                                        )} */}
                                </>
                            )}
                        </div>
                    </div>

                    <div className="listContent">
                        <h2 onClick={props.drawerHandler} className="listProdTitle">
                            {product.title}
                        </h2>
                        <div className="listLotDetails">{HtmlToText(product.desc_proc)}</div>

                        {/* <div className="listBidInfo d-flex justify-content-start align-items-center">
                            <h6>{t('auction')} id:</h6>
                            <p className="d-flex justify-content-between align-items-center">
                                <span>{`#${product.auctionid}`}</span>
                            </p>
                        </div> */}

                        {product.market_status === 'open' ? (
                            <>
                                {product.auction ? (
                                    <div className="listBidInfo d-flex justify-content-start align-items-center">
                                        <h6>{product.cbidtext}:</h6>
                                        <p className="d-flex justify-content-between align-items-center">
                                            <span>{currencyFormat(product.wprice)}</span>
                                            <span className="listDivider">|</span>
                                            <span
                                                className="cursorDecoy"
                                                onClick={() => setBidHistoryValue(product.id)}
                                            >
                                                {product.bid_count} Bids
                                            </span>
                                        </p>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {product.buynow && product.wprice < product.bprice ? (
                                    <div className="listBidInfo d-flex justify-content-start align-items-center">
                                        <h6>Buy Now Price:</h6>
                                        <p className="d-flex justify-content-between align-items-center">
                                            <span>
                                                {currencyFormat(product.bprice * product.qty)}
                                            </span>
                                        </p>
                                    </div>
                                ) : (
                                    ''
                                )}
                            </>
                        ) : (
                            <div className="listBidInfo d-flex justify-content-start align-items-center">
                                <h6>{product.cbidtext}:</h6>
                                <p className="d-flex justify-content-between align-items-center">
                                    <span>{currencyFormat(product.buynowamount)}</span>
                                    {product.market_status === 'open' ? (
                                        <>
                                            <span className="listDivider">|</span>
                                            <span
                                                className="cursorDecoy"
                                                onClick={() => setBidHistoryValue(product.id)}
                                            >
                                                {product.bid_count} Bids
                                            </span>
                                        </>
                                    ) : null}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="listActBtn">
                    {product.market_status === 'open' ? (
                        <>
                            <div className="d-flex justify-content-center align-items-center flex-wrap">
                                <p className="d-flex align-items-center timerListView flex-wrap">
                                    <span className="material-icons-outlined">timer</span>
                                    {product.date_closed ? (
                                        <span>
                                            {' '}
                                            <Timer
                                                date_added={product.date_added}
                                                date_closed={product.date_closed}
                                                withText={1}
                                                endText={'Time left' + ':'}
                                                startText={'Starts in' + ':'}
                                            ></Timer>
                                        </span>
                                    ) : null}
                                </p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="listTimer d-flex justify-content-between align-items-center flex-wrap">
                                <h6 className="w-100">Closed on:</h6>
                                <p className="d-flex justify-content-center align-items-center w-100">
                                    {dateFormatFront(product.date_closed)}
                                </p>
                            </div>
                        </>
                    )}
                    {props.from === 'dashboard' &&
                    (props.action === 'won' || props.action === 'buynow') &&
                    product.buynowed &&
                    product.buynowed === user.id ? (
                        <div className="actionAfterWin">
                            {parseInt(product.buynowpaid, 10) === 1 ? (
                                <>
                                    <SecondaryButton
                                        id="listView_common_invoice"
                                        label="View invoice"
                                        btnSize="small"
                                        onClick={() =>
                                            handleRedirectInternal(
                                                history,
                                                `invoice/${product.common_invoice}`,
                                            )
                                        }
                                    />
                                </>
                            ) : (
                                <>
                                    <PrimaryButton
                                        id="make_pay_list"
                                        label="Make payment"
                                        btnSize="small"
                                        onClick={() =>
                                            handleRedirectInternal(
                                                history,
                                                `checkout/invoice/${product.common_invoice}`,
                                            )
                                        }
                                    />
                                </>
                            )}
                        </div>
                    ) : product.market_status === 'open' && !product.future_active ? (
                        <>
                            <div className="listBidBox">
                                {product.auction ? (
                                    <>
                                        {product.auctiontype == 'reverse' ? (
                                            <ReverseBidding
                                                data={product}
                                                type={
                                                    parseInt(
                                                        configVariables?.proxy_bidding_settings,
                                                    ) === 0
                                                        ? 'hard'
                                                        : 'proxy'
                                                }
                                            />
                                        ) : product.custom_auctionlot_bid_type ? (
                                            <Bidding
                                                data={product}
                                                type={`${product.custom_auctionlot_bid_type}`}
                                            />
                                        ) : (
                                            <Bidding data={product} type={'hard'} />
                                        )}
                                    </>
                                ) : (
                                    <Buynow
                                        data={product}
                                        editQuantity={false}
                                        isOnlyBuynow={product.auction === 0 ? true : false}
                                    />
                                )}
                            </div>
                        </>
                    ) : product.buynowed && product.buynowed === user.id ? (
                        <div className="actionAfterWin">
                            {parseInt(product.buynowpaid, 10) === 1 ? (
                                <>
                                    <SecondaryButton
                                        id="listView_paid_invoice"
                                        label="View invoice"
                                        btnSize="small"
                                        onClick={() =>
                                            handleRedirectInternal(
                                                history,
                                                `invoice/${product.common_invoice}`,
                                            )
                                        }
                                    />
                                </>
                            ) : (
                                <>
                                    <PrimaryButton
                                        id="make_pay_list"
                                        label="Make payment"
                                        btnSize="small"
                                        onClick={() =>
                                            handleRedirectInternal(
                                                history,
                                                `checkout/invoice/${product.common_invoice}`,
                                            )
                                        }
                                    />
                                </>
                            )}
                        </div>
                    ) : null}
                    <div className="moreInfo">
                        <Button id="listView_info" onClick={props.drawerHandler}>
                            View more info
                            <span className="material-icons">arrow_right_alt</span>
                        </Button>
                    </div>
                </div>
            </div>
        </Fade>
    )
}
export default ListView
